<div class="container">
  <app-header class="header" [title]="'VOD'"></app-header>
  <app-vod-grid [config]="vodgridconfig"></app-vod-grid>
  <app-vod-summary [config]="vodsummaryconfig"></app-vod-summary>
</div>
